import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';

interface CardBorderProps {
    borderWidthTypeNormal: number
    borderWidthTypeHover: number
    borderWidthTypeActive: number
    borderColorTypeNormal: string
    borderColorTypeHover: string
    borderColorTypeActive: string
    borderRadius: number
}

const createStyle = ({
  borderWidthTypeNormal,
  borderWidthTypeHover,
  borderWidthTypeActive,
  borderColorTypeNormal,
  borderColorTypeHover,
  borderColorTypeActive,
  borderRadius,
}: CardBorderProps) => StyleSheet.create({
  border: {
    transition: '0.2s border ease-in-out',
    willChange: 'border',
    zIndex: 1,
    width: '100%',
    height: '100%',
    position: 'absolute',
    bottom: '0px',
    boxSizing: 'border-box',
    borderRadius: `${borderRadius}px`,
    border: `${borderWidthTypeNormal}px solid ${borderColorTypeNormal}`,
    ':hover': {
      border: `${borderWidthTypeHover}px solid ${borderColorTypeHover}`,
    },
    ':active': {
      border: `${borderWidthTypeActive}px solid ${borderColorTypeActive}`,
    },
  },
});

export const CardBorder: React.FunctionComponent<CardBorderProps> = props => {
  const style = createStyle(props);
  return <div className={css(style.border)} />;
};
